// 檢查裝置是否為 iPad
function isIpad() {
	// return /iPad|Macintosh/i.test(navigator.userAgent) && 'ontouchend' in document;

	// 新版?
	return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}
let deviceInited = false;
function initDevice() {
	if (deviceInited) return;
	deviceInited = true;

	const deviceQuery = window.matchMedia('(min-width: 1201px)');

	window.device = deviceQuery.matches ? 'desktop' : 'mobile';

	deviceQuery.addEventListener('change', (e) => {
		const newDevice = e.matches ? 'desktop' : 'mobile';

		if (window.device !== newDevice) {
			window.device = newDevice;
			location.reload();
		}
	});

	// iPad Landscape Lock
	const ipadLandscapeQuery = window.matchMedia(
		'(min-width: 1101px) and (max-width: 1399px)'
	);

	function updateIpadLandscapeLock() {
		const lockEl = document.getElementById('landscape-lock');
		if (!lockEl) return;

		if (ipadLandscapeQuery.matches && isIpad()) {
			lockEl.classList.remove('hidden');
		} else {
			lockEl.classList.add('hidden');
		}
	}

	updateIpadLandscapeLock();
	ipadLandscapeQuery.addEventListener('change', updateIpadLandscapeLock);

	if (navigator.appVersion.indexOf("Mac") != -1) {
		$("body").get(0).style.setProperty('--lock', "15px");
	} else {
		$("body").get(0).style.setProperty('--lock', "17px");
	}
}

initDevice()